import React from "react";
import { Card, Tag, Tooltip, Avatar, Button } from "antd";
import { Link } from "react-router-dom";
import {
  CalendarOutlined,
  UserOutlined,
  MailOutlined,
} from "@ant-design/icons";
import { PERMISSIONS } from "../../../config/permission";
import ProtectedAction from "../../../Routes/ProtectedRoutes/ProtectedAction";

const statusColors = {
  applied: "blue",
  "in-progress": "orange",
  selected: "green",
  rejected: "red",
};

const ApplicantCard = ({ applicant, onClick }) => {
  const round = applicant.roundHistory?.find(
    (r) => r.roundName === applicant.currentRound,
  );
  

  const applicationId = applicant._id;
  const roundId = round?._id;

  const applicantName =
    applicant?.applicantName || applicant?.formData?.fullName || "Applicant";

  const email = applicant?.applicantEmail ||applicant?.formData?.email || "No email";

  const initial = applicantName.charAt(0).toUpperCase();

  return (
    <Card
      hoverable
      size="small"
      style={{
        marginBottom: 12,
        borderRadius: 12,
        border: "1px solid #f0f0f0",
        transition: "all 0.25s ease",
      }}
      bodyStyle={{ padding: 16 }}
      onClick={() => onClick(applicant)}
    >
      <div style={{ display: "flex", alignItems: "flex-start", gap: 12 }}>
        {/* Avatar */}
        <Avatar
          size={40}
          style={{
            background: "#7F35CD",
            fontWeight: 600,
          }}
          icon={!initial && <UserOutlined />}
        >
          {initial}
        </Avatar>
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 600, fontSize: 15 }}>{applicantName}</div>
          <div
            style={{
              fontSize: 12,
              color: "#777",
              display: "flex",
              alignItems: "center",
              gap: 6,
              marginTop: 2,
            }}
          >
            <MailOutlined style={{ fontSize: 11 }} />
            {email}
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              marginTop: 10,
            }}
          >
            <Tag
              color={statusColors[applicant.overallStatus]}
              style={{
                textTransform: "capitalize",
                fontWeight: 500,
                borderRadius: 6,
              }}
            >
              {applicant.overallStatus}
            </Tag>

            {applicationId && roundId && (
              <ProtectedAction
                requiredPermission={PERMISSIONS.SCHEDULE_JOB_INTERVIEW}
              >
                <Tooltip title="Schedule Interview">
                  <Link to={`/interview/${applicant?.jobId?._id}/${applicationId}/${roundId}`}>
                    <Button
                      size="small"
                      icon={<CalendarOutlined />}
                      style={{
                        borderRadius: 6,
                        fontWeight: 500,
                      }}
                    >
                      Schedule
                    </Button>
                  </Link>
                </Tooltip>
              </ProtectedAction>
            )}
          </div>
        </div>
      </div>
    </Card>
  );
};

export default ApplicantCard;
